import { HeadingBlock } from '@design-system/heading-block';
import { PageBlock } from '@design-system/page-block';
import { PromoQuizBlock } from '@design-system/promo-quiz-block';
import React, { FC, useCallback, useMemo, useState } from 'react';

import { useCurrentLang } from '~/hooks/useCurrentLang';
import { itemListingMapper } from '~/mappers/itemListing';

import ItemListing from '../ItemListing';
import { PromoQuizCSProps, PromoQuizResults } from './models';

const PromoQuiz: FC<PromoQuizCSProps> = ({
  pageBlockUI,
  componentId,
  heading,
  quiz: { quizId, url },
  uid,
  itemListingGrids = [],
}) => {
  const [results, setResults] = useState<PromoQuizResults>();
  const {
    currentLang: { locale: currentLangCode },
  } = useCurrentLang();

  const handleResults = useCallback((quizResults: PromoQuizResults) => {
    setResults(quizResults);
  }, []);

  const listingProps = useMemo(() => {
    if (results?.resultValues) {
      const itemListingGrid = itemListingGrids.find(
        (item) =>
          results?.resultValues?.includes(item.uid) &&
          currentLangCode === item.publishDetails.locale
      );

      return itemListingGrid ? itemListingMapper(itemListingGrid, uid) : null;
    }

    return null;
  }, [results, itemListingGrids, uid, currentLangCode]);

  return (
    <PageBlock
      {...pageBlockUI}
      id={componentId}
      className="promo-quiz"
      componentUid={uid}
    >
      {heading ? <HeadingBlock {...heading} /> : null}
      <PromoQuizBlock callback={handleResults} quizId={quizId} url={url} />
      {listingProps ? (
        <div className="promo-quiz__listing">
          <ItemListing {...listingProps} />
        </div>
      ) : null}
    </PageBlock>
  );
};

export default PromoQuiz;
